.plan-header {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-auto-flow: row;
  grid-row: 1 / -1;

  gap: var(--space-16);

  padding: var(--space-24) var(--space-16) var(--space-16) var(--space-16);
  border-radius: 8px;

  &.is-selected {
    background-color: var(--blue-EDF6FF);
    box-shadow:
      inset 2px 0 0 0 var(--blue-1D5AD8),
      inset -2px 0 0 0 var(--blue-1D5AD8),
      inset 0 2px 0 0 var(--blue-1D5AD8),
      inset 0 -2px 0 0 var(--blue-1D5AD8);
  }

  &.is-current {
    background-color: var(--gray-F9FAFB);
  }
}

.shipment-limit-and-user-count {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: var(--lineup-plan-grid-row-shipment-limit-label) / var(--lineup-plan-grid-row-divider);
  gap: var(--space-8);
}

.divider {
  grid-row: var(--lineup-plan-grid-row-divider);
  border-bottom: solid 1px var(--gray-DFE4E8);
}

.plan-info {
  display: grid;
  grid-template-rows: subgrid;
  grid-row: var(--lineup-plan-grid-row-name) / var(--lineup-plan-grid-row-shipment-limit);
}

.plan-name-row {
  grid-row: var(--lineup-plan-grid-row-name);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 28px;
}

.plan-name {
  color: var(--gray-212c36);
}

.plan-current-price {
  grid-row: var(--lineup-plan-grid-row-current-price);
  color: var(--gray-212c36);
}

@keyframes highlight-flash {
  0% {
    background-color: var(--blue-DBECFE);
  }
  100% {
    background-color: transparent;
  }
}

.highlight {
  animation: highlight-flash 1.5s ease-out;
}

.plan-option-content-cost {
  display: flex;
  align-items: center;
  color: var(--gray-56595D);
}

.plan-option-content-cost-strikethrough {
  text-decoration: line-through;
  color: var(--gray-8D9196);
  margin-right: var(--space-4);

  @media (--tablet), (--mobile), (--ultramobile) {
    display: none;
  }
}
